import Reveal from "@/components/site/Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "We put instruments where humans can't go.",
    body: "Miles below the seabed, pressure and temperature turn steel brittle. We send armored electrical cable down that hole — carrying tools that measure, image and act — and bring the truth back to surface.",
  },
  {
    n: "02",
    title: "The cable is the connection.",
    body: "Wireline is data at depth. Every conductor is a live link between a downhole instrument and the engineer at surface. When the reading has to be right the first time, the line has to be perfect.",
  },
  {
    n: "03",
    title: "Offshore is not an excuse.",
    body: "Rig time is measured in tens of thousands per day. Our crews rig up fast, log clean and rig down safe — on floaters, jack-ups and platforms in any sea state we're cleared to work.",
  },
];

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      className="relative border-b border-white/10 bg-background py-24 md:py-40"
      data-testid="manifesto-section"
    >
      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <Reveal className="mb-16 md:mb-28 max-w-4xl">
          <span className="mono-label text-primary">/ Who we are</span>
          <h2 className="mt-6 font-display font-bold uppercase tracking-tight text-3xl md:text-5xl lg:text-6xl leading-[0.95]">
            A wireline operator built around one job — getting the tool to depth and the
            data back.
          </h2>
        </Reveal>

        <div className="divide-y divide-white/10 border-t border-white/10">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.05}>
              <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-12 md:py-16 group">
                <div className="md:col-span-3">
                  <span className="font-mono-tech text-6xl md:text-7xl text-muted-foreground/40 group-hover:text-primary transition-colors duration-500">
                    {c.n}
                  </span>
                </div>
                <h3 className="md:col-span-5 font-display font-medium text-2xl md:text-3xl tracking-tight leading-tight">
                  {c.title}
                </h3>
                <p className="md:col-span-4 text-foreground/60 text-base md:text-lg leading-relaxed self-end">
                  {c.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
